import { useState, useEffect } from "react";
const useBrowser = (deviceQuery, browserQuery) => {
  const [matchDevice, setMatchDevice] = useState(false);
  const [matchBrowser, setMatchBrowser] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const bodyElement = document.body.className;
    setMatchDevice(
      deviceQuery.trim() !== "" && bodyElement.includes(deviceQuery),
    );
    setMatchBrowser(
      browserQuery.trim() !== "" && bodyElement.includes(browserQuery),
    );
  }, [deviceQuery, browserQuery]);

  return { matchDevice, matchBrowser };
};

export default useBrowser;
